const initialState = {
  adults_qty: { adultsQuantity: 1 },
  cabin_type: '',
  childs: [],
  chosen_airlines: [],
  flexible_date: false,
  id_integration: 0,
  dataTripLegs: [],
  trip_type: 'MultipleFlights',
};

const flightsSearchMultipleDestination = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SEARCH_FLIGHTS_MULTIPLEDESTINATION':
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default flightsSearchMultipleDestination;
